import { Subject } from "rxjs";
import apiResponse from "../../../../services/apiResponse";
import UpdateRepository from "../Repositories/UpdateRepository";

class UpdateBloc {
  createChannel = new Subject();
  detailChannel = new Subject();
  portalServiceChannel = new Subject();
  repository = new UpdateRepository();

  constructor() {
    this.createChannel.next({ status: apiResponse.INITIAL });
    this.detailChannel.next({ status: apiResponse.INITIAL });
    this.portalServiceChannel.next({ status: apiResponse.INITIAL });
  }

  fetchUpdate = async (query) => {
    this.createChannel.next({ status: apiResponse.LOADING });
    await this.repository
      .fetchUpdate(query)
      .then((result) => {
        this.createChannel.next({
          status: apiResponse.COMPLETED,
          data: result,
        });
      })
      .catch((error) => {
        this.createChannel.next({ status: apiResponse.ERROR, data: error });
      });
  };

  fetchDetail = async (query) => {
    await this.repository
      .fetchDetail(query)
      .then((result) => {
        this.detailChannel.next({
          status: apiResponse.COMPLETED,
          data: result,
        });
      })
      .catch((error) => {
        this.detailChannel.next({ status: apiResponse.ERROR, data: error });
      });
  };

  fetchPortalServices = async (query) => {
    this.portalServiceChannel.next({ status: apiResponse.LOADING });
    await this.repository
      .fetchPortalServices(query)
      .then((result) => {
        this.portalServiceChannel.next({
          status: apiResponse.COMPLETED,
          data: result,
        });
      })
      .catch((error) => {
        this.portalServiceChannel.next({ status: apiResponse.ERROR, data: error });
      });
  };
}

export default UpdateBloc;
